import {
  dataProvider,
  authProvider,
  storageDataProvider,
  appDataProvider,
  userDataProvider,
  accessControlProvider,
} from "@taruvi/refine-providers";
import { taruviClient } from "../taruviClient";

// Define TaruviUser interface locally (not exported by package)
export interface TaruviUser {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
}

// Re-export types for easy access throughout the app
export type {
  TaruviMeta,
  TaruviListResponse,
  StorageUploadVariables,
  LoginParams,
  LogoutParams,
  RegisterParams,
} from "@taruvi/refine-providers";

// Re-export utility functions for advanced usage
export {
  buildRefineQueryParams,
  convertRefineFilters,
  convertRefineSorters,
  convertRefinePagination,
  buildQueryString,
  REFINE_OPERATOR_MAP,
} from "@taruvi/refine-providers";

/**
 * Official Refine providers from @taruvi/refine-providers
 *
 * Available providers:
 * - taruviDataProvider (default): Database CRUD operations
 * - taruviStorageProvider (storage): File upload/download/delete
 * - taruviAppProvider (app): App-level data (roles, functions, analytics)
 * - taruviUserProvider (user): Current user data
 * - taruviAuthProvider: Authentication (login, logout, check, getIdentity)
 * - taruviAccessControlProvider: Cerbos-based permission checks (with DataLoader batching)
 */

// Database CRUD operations (default data provider)
export const taruviDataProvider = dataProvider(taruviClient);

// Authentication operations (login, logout, check, getIdentity, getPermissions)
export const taruviAuthProvider = authProvider(taruviClient);

// Storage operations (file upload, download, delete from buckets)
export const taruviStorageProvider = storageDataProvider(taruviClient);

// App operations (roles, functions, analytics)
export const taruviAppProvider = appDataProvider(taruviClient);

// User operations (get current user via useOne with resource="me", or roles via useList)
export const taruviUserProvider = userDataProvider(taruviClient);

// Access control provider (Cerbos-based permission checks via useCan)
export const taruviAccessControlProvider = accessControlProvider(taruviClient);
